import React from "react";
import { Box, Typography } from "@material-ui/core";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";

export default function LimitedTimeOffer({ limitedTimeOffer = {}, buttons = [] }) {
  const copyCodeBtn = buttons.find((b) => b.type === "COPY_CODE");
  const couponCode = copyCodeBtn?.example || copyCodeBtn?.buttonValue;
  const offerText = limitedTimeOffer.text;

  return (
    <Box
      style={{
        padding: "6px 16px",
        display: "flex",
        alignItems: "center",
        gap: 6,
      }}
    >
      <Box
        style={{
          background: "#2e7d32",
          borderRadius: "50%",
          width: 24,
          height: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <CardGiftcardIcon style={{ color: "#fff", fontSize: 14 }} />
      </Box>
      <Box>
        {offerText && (
          <Typography style={{ fontSize: 12, color: "#555", fontWeight: 500 }}>{offerText}</Typography>
        )}
        <Typography style={{ fontSize: 13, color: "#333" }}>
          code : {couponCode !== undefined && couponCode !== "" ? couponCode : "undefined"}
        </Typography>
      </Box>
    </Box>
  );
}
